if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();

				// ── Cache for fetched product HTML (keyed by product URL) ────────────
				this._fetchCache = new Map();

				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

				window.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE") this.hide();
				});

				// ✅ Close when clicking outside the modal content (on the backdrop)
				this.addEventListener("click", (event) => {
					if (!this.modalContent.contains(event.target)) {
						console.log("close when clicking outside the modal content");
						this.hide();
					}
					console.log("else close when clicking outside the modal content");
				});

				// ── Prefetch product HTML on hover so fetch is instant on click ──────
				// Uses <link rel="prefetch"> which populates the browser's cache.
				// The fetch() call in show() will then resolve from cache immediately.
				document.addEventListener(
					"mouseover",
					(event) => {
						const opener = event.target.closest("[data-product-url]");
						if (!opener || opener._prefetched) return;
						opener._prefetched = true;

						const link = document.createElement("link");
						link.rel = "prefetch";
						link.href = opener.getAttribute("data-product-url");
						link.as = "fetch";
						document.head.appendChild(link);
					},
					{ passive: true }
				);
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

				// Destroy all Swiper instances initialised by _initQuickAddSliders
				this.modalContent
					.querySelectorAll(".product__media-list")
					.forEach((el) => el.swiper?.destroy(true, true));

				this.modalContent.innerHTML = "";

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				const url = opener.getAttribute("data-product-url");

				// ── Use cached HTML if available, otherwise fetch (and cache) ────────
				const cached = this._fetchCache.get(url);
				const request = cached
					? Promise.resolve(cached)
					: fetch(url)
							.then((response) => response.text())
							.then((html) => {
								this._fetchCache.set(url, html);
								return html;
							});

				request
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);

						// ✅ Init sliders AFTER content is injected into the live DOM
						// and after super.show() makes the modal visible (display:block),
						// so Swiper can correctly measure element dimensions.
						this._initQuickAddSliders();
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						const selectDropDown = () => {
							$(".product-form__controls--dropdown").each(function () {
								const elListItem = $(this).find(".dropdown-select ul li");
								const elItem = $(this).find(".dropdown-select ul");
								const selectedText = $(this).find(
									".dropdown-select .select-label"
								);

								selectedText.on("click", function (e) {
									elItem.toggleClass("active");
									if (elItem.hasClass("active")) {
										e.stopPropagation();
										$(document).click(function () {
											elItem.removeClass("active");
										});
									}
								});

								elListItem.on("click", function () {
									selectedText
										.find("span")
										.text($(this).text())
										.attr("title", $(this).text());
									elItem.removeClass("active");
									document.activeElement.blur();
								});
							});
						};

						selectDropDown();
					});
			}

			/**
			 * Self-contained Swiper initialiser for the quick-add modal.
			 *
			 * Key problems solved:
			 * - The PDP pre-renders some variant images mid-stream in the Swiper
			 *   wrapper, causing wrong slide order (e.g. 1,6,2,3...).
			 * - Swiper measures wrong widths if booted during the modal's CSS
			 *   transition; fixed by calling swiper.update() + slideTo(0) after
			 *   transitionend (with a setTimeout fallback).
			 */
			_initQuickAddSliders() {
				const modal = this.modalContent;

				// Tear down any stale instances (rapid open/close guard)
				modal.querySelectorAll(".product__media-list").forEach((el) => {
					el.swiper?.destroy(true, true);
				});

				const sliderWrapper = modal.querySelector(".product__media-list");
				if (!sliderWrapper) return;

				// ── 1. Build the canonical slide order from the noscript grid ────────
				const noscriptGrid = modal.querySelector(
					".product__media-grid-noscript .product__media-list"
				);

				if (noscriptGrid) {
					sliderWrapper.innerHTML = "";

					noscriptGrid
						.querySelectorAll(".product__media-item[data-media-id]")
						.forEach((item) => {
							const clone = item.cloneNode(true);
							clone.classList.add("swiper-slide");
							clone.querySelectorAll("img").forEach((img) => {
								img.classList.add("img-responsive");
							});
							sliderWrapper.appendChild(clone);
						});
				}

				// ── 2. Wrap in a .swiper shell if not already present ────────────────
				let swiperContainer = sliderWrapper.closest(".swiper");
				if (!swiperContainer) {
					const parent = sliderWrapper.parentElement;
					const shell = document.createElement("div");
					shell.className = "swiper quick-add-swiper";
					parent.insertBefore(shell, sliderWrapper);
					shell.appendChild(sliderWrapper);
					swiperContainer = shell;
				}
				sliderWrapper.classList.add("swiper-wrapper");

				// ── 3. Clip the half-visible slide + inject nav buttons ──────────────
				swiperContainer.style.overflow = "hidden";

				if (!swiperContainer.querySelector(".swiper-button-prev")) {
					swiperContainer.insertAdjacentHTML(
						"beforeend",
						`
						<div class="swiper-button-prev quick-add-nav"></div>
						<div class="swiper-button-next quick-add-nav"></div>
					`
					);
				}

				// ── 4. Slide counter ─────────────────────────────────────────────────
				const getCounter = () =>
					sliderWrapper.querySelector(".image_number .first_number");

				// ── 5. Boot Swiper ───────────────────────────────────────────────────
				const swiper = new Swiper(swiperContainer, {
					direction: "horizontal",
					slidesPerView: 2.5,
					spaceBetween: 8,
					loop: false,
					initialSlide: 0,
					navigation: {
						nextEl: swiperContainer.querySelector(".swiper-button-next"),
						prevEl: swiperContainer.querySelector(".swiper-button-prev"),
					},
					on: {
						afterInit(sw) {
							const counter = getCounter();
							if (counter) counter.textContent = `1 / `;
						},
						slideChange(sw) {
							const counter = getCounter();
							if (counter) counter.textContent = `${sw.activeIndex + 1} / `;
						},
					},
				});

				sliderWrapper.swiper = swiper;

				// ── 6. Re-measure + reset to slide 0 after modal transition ends ─────
				// Reduced from 400ms → 150ms; modal transitions are typically ~200ms
				// so this fires well after the animation has settled.
				const transitionTarget =
					this.querySelector(".modal-container, dialog, .modal__content") ||
					this;

				let corrected = false;
				const correct = () => {
					if (corrected) return;
					corrected = true;
					transitionTarget.removeEventListener("transitionend", correct);
					swiper.update();
					swiper.slideTo(0, 0);
					const counter = getCounter();
					if (counter) counter.textContent = `1 / `;
				};

				transitionTarget.addEventListener("transitionend", correct);

				// Fallback: reduced from 400ms → 150ms
				setTimeout(correct, 150);
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects script tags to allow execution.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});

				// Read more button
				const moreBtn = document.createElement("a");
				moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>`;
				moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
				moreBtn.setAttribute(
					"class",
					"product__full-details button button--simple"
				);
				element
					.querySelector(".product .product__info-main_content")
					.appendChild(moreBtn);
			}

			removeDOMElements() {
				const modal = this.productElement.querySelector("product-modal");
				if (modal) modal.remove();

				const popup = this.productElement.querySelectorAll(".product-popup");
				if (popup) popup.forEach((el) => el.remove());

				const reviews = this.productElement.querySelector(
					'[data-block-handle="reviews"]'
				);
				if (reviews) reviews.remove();

				const about = this.productElement.querySelectorAll(".about");
				if (about) about.forEach((el) => el.remove());

				const iconText = this.productElement.querySelectorAll(
					".product__text-icon"
				);
				if (iconText) iconText.forEach((el) => el.remove());

				const shareButtons =
					this.productElement.querySelector(".share-buttons");
				if (shareButtons) shareButtons.remove();

				const tags = this.productElement.querySelector(".product-tags");
				if (tags) tags.remove();

				const pickupAvailability = this.productElement.querySelector(
					".pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const description = this.productElement.querySelector(
					".product__description"
				);
				if (description) description.remove();

				const recommendations = this.productElement.querySelector(
					"product-recommendations"
				);
				if (recommendations) recommendations.remove();

				const product__popup =
					this.productElement.querySelector(".product__popup");
				if (product__popup) product__popup.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}